module.exports = __webpack_public_path__ + "assets/ee7d3600fc36df82e790e9f38aa80eb7.jpg";